.eb{background:var(--palette-white);}